'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'ranking-star';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e561';
var svgPathData = ['M16 368l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0c-17.7 0-32 14.3-32 32zm160-64l0 192 160 0 0-192c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm12.5-199.1l30.1 30.2c1.8 1.8 2.6 4.4 2.2 6.9l-6.7 42.1 38-19.3 1.8-.7c1.8-.4 3.8-.2 5.5 .7l37.9 19.3-6.6-42.1c-.4-2.5 .4-5.1 2.2-6.9l30.1-30.2-42.1-6.7c-2.5-.4-4.7-2-5.9-4.3l-19.3-38-19.3 38c-1.2 2.3-3.4 3.8-5.9 4.3l-42.1 6.7zM352 368l0 128 112 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-112 0z', 'M304 256c26.5 0 48 21.5 48 48l0 48 112 0 4.9 .2c24.2 2.5 43.1 22.9 43.1 47.8l0 64-.2 4.9c-2.3 22.6-20.3 40.6-42.8 42.8l-4.9 .2-416 0-4.9-.2C18.9 509.3 0 488.8 0 464l0-96c0-24.9 18.9-45.3 43.1-47.8l4.9-.2 112 0 0-16c0-26.5 21.5-48 48-48l96 0zM48 336c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0zm160-64c-17.7 0-32 14.3-32 32l0 192 160 0 0-192c0-17.7-14.3-32-32-32l-96 0zM352 496l112 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-112 0 0 128zM255.8 30.4c3 0 5.8 1.7 7.1 4.4l24.6 48.3 53.5 8.5c3 .5 5.4 2.6 6.3 5.4s.2 6-1.9 8.1l-38.3 38.4 8.4 53.6c.5 3-.8 6-3.2 7.7s-5.7 2-8.3 .7l-48.3-24.6-48.3 24.6c-2.7 1.4-5.9 1.1-8.3-.7s-3.7-4.8-3.2-7.7l8.4-53.6-38.2-38.4c-2.1-2.1-2.9-5.3-1.9-8.1s3.4-4.9 6.3-5.4l53.5-8.5 24.7-48.3 1.2-1.8c1.5-1.6 3.6-2.6 5.9-2.6zM236.5 94c-1.2 2.3-3.4 3.8-5.9 4.3l-42.1 6.7 30.1 30.2c1.8 1.8 2.6 4.4 2.2 6.9l-6.7 42.1 38-19.3 1.8-.7c1.8-.4 3.8-.2 5.5 .7l37.9 19.3-6.6-42.1c-.4-2.5 .4-5.1 2.2-6.9l30.1-30.2-42.1-6.7c-2.5-.4-4.7-2-5.9-4.3l-19.3-38-19.3 38z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRankingStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;